export const getPerformancePreferences = () => {
  if (typeof window === 'undefined') {
    return {
      reduceEffects: false,
      canUseHeavyMedia: true,
      reasons: []
    };
  }

  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const coarsePointer = window.matchMedia('(pointer: coarse)').matches;
  const smallScreen = window.matchMedia('(max-width: 768px)').matches;
  const saveData = Boolean(connection?.saveData);
  const slowConnection = ['slow-2g', '2g'].includes(connection?.effectiveType);
  const lowMemory = typeof navigator.deviceMemory === 'number' && navigator.deviceMemory <= 4;
  const lowCpu = typeof navigator.hardwareConcurrency === 'number' && navigator.hardwareConcurrency <= 4;

  const reasons = [
    prefersReducedMotion && 'reduced-motion',
    saveData && 'save-data',
    slowConnection && 'slow-connection',
    lowMemory && 'low-memory',
    lowCpu && 'low-cpu',
    coarsePointer && 'coarse-pointer',
    smallScreen && 'small-screen'
  ].filter(Boolean);

  return {
    reduceEffects: prefersReducedMotion || saveData || slowConnection || lowMemory || lowCpu,
    canUseHeavyMedia: !prefersReducedMotion && !saveData && !slowConnection && !lowMemory && !smallScreen,
    reasons
  };
};

